import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useAxios from "../axios";

export const useComments = (params) => {
  const instanceWithToken = useAxios();

  return useQuery({
    queryKey: ["getComments", params],
    queryFn: async () => {
      const { data } = await instanceWithToken.get("comment/all", {
        params,
      });
      return data;
    },
  });
};

export const useGetUserComments = (params) => {
  const instanceWithToken = useAxios();

  return useQuery({
    queryKey: ["getUserComments", params],
    queryFn: async () => {
      const { data } = await instanceWithToken.get("user/comment/all", {
        params,
      });
      return data;
    },
  });
};

export const useAddComment = () => {
  const instanceWithToken = useAxios();

  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.post("comment", body);
      return data;
    },
  });
};

export const useEditComment = () => {
  const instanceWithToken = useAxios();

  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.patch("comment", body);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getComments"] });
    },
  });
};

export const useDeleteComment = () => {
  const instanceWithToken = useAxios();

  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.delete("comment", body);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getComments"] });
    },
  });
};

export const useUpdateCommentByTeacher = () => {
  const instanceWithToken = useAxios();

  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.post("teacher/comment", body);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getComments"] });
    },
  });
};